import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// guards
import { AuthGuard } from '../data/guard/auth.guard';
import { FeatureArrivalGuard } from '../data/guard/feature-arrival.guard';
import { FormCanDeactivateGuard } from '../data/guard/form-can-deactivate.guard';
import { LoginGuard } from '../data/guard/login.guard';
//enums
import { UserFormResolver } from '../data/resolvers/user-form.resolver';
import { ProfileGuard } from '../data/guard/profile.guard';
// Agenda+ routes
import { UserDetailsComponent } from '../ui/components/user-details/user-details.component';
//TODO: POR FAVOR!!! COLOQUEM AS ROTAS DO CHEGUEI SEPARADAS !!!!!!!!!
import { GateListComponent } from '../ui/pages/arrival/gate/gate-list/gate-list.component';
import { MonitoringComponent } from '../ui/pages/arrival/gates-monitoring/monitoring.component';
import { ForgotPasswordComponent } from '../ui/pages/auth/forgot-password/forgot-password.component';
import { LoginBypassComponent } from '../ui/pages/auth/login-bypass/login-bypass.component';
import { LoginComponent } from '../ui/pages/auth/login/login.component';
import { ResetPasswordComponent } from '../ui/pages/auth/reset-password/reset-password.component';
import { ChatsDetailsComponent } from '../ui/pages/chats/chats-details/chats-details.component';
import { ChatsPageComponent } from '../ui/pages/chats/chats.component';
import { EventComponent } from '../ui/pages/events/event.component';
import { EventsListComponent } from '../ui/pages/events/events-list/events-list.component';
import { NewsListComponent } from 'src/app/modules/news/components/news-list/news-list.component';
import { NewsComponent } from 'src/app/modules/news/components/news/news.component';
import { PageNotFoundComponent } from '../ui/pages/page-not-found/page-not-found.component';
import { RegisterComponent } from '../ui/pages/register/register.component';
import { UserFormComponent } from '../ui/pages/user-list/form/user-fom/user-form.component';
import { UserListComponent } from '../ui/pages/user-list/user-list.component';
import { ChannelsComponent } from './channels/channels.component';
import { LinksComponent } from './links/links.component';
import { NewsDetailsComponent } from './news/components/news-details/news-details.component';
import { IntercomGuard } from '../data/guard/intercom.guard';
import { ShowsComponent } from './shows/shows.component';
import { SelectTenantComponent } from '../ui/pages/auth/select-tenant/select-tenant.component';
import { AuthLayoutComponent } from '../ui/layouts/auth-layout/auth-layout.component';
import { PublicLayoutComponent } from '../ui/layouts/public-layout/public-layout.component';
import {
  BUSINESS_PROFILES,
  EMPLOYEES_PROFILES,
  RESTRICTED_ROUTE_PROFILES,
} from '../data/utils/profile.utils';
import { SelectSchoolComponent } from '../ui/pages/auth/select-school/select-school.component';

const authRoutes: Routes = [
  {
    path: '',
    component: AuthLayoutComponent,
    canActivate: [AuthGuard, IntercomGuard],
    children: [
      {
        path: 'shows',
        component: ShowsComponent,
        data: { title: 'Eventos' },
      },
      {
        path: 'links',
        component: LinksComponent,
        data: { title: 'Aplicativo' },
      },
      {
        path: 'channels',
        component: ChannelsComponent,
        data: {
          disableDrawer: true,
          title: 'Canais de atendimento',
          backPath: 'chat',
        },
      },
      /* ============= GATES MONITORING =============== */
      {
        path: 'gates-monitoring/:idGate',
        component: MonitoringComponent,
        canActivate: [FeatureArrivalGuard],
        data: { disableDrawer: true, title: 'Monitoramento' },
      },

      /* ============= GATES =============== */
      {
        path: 'gate-list',
        component: GateListComponent,
        canActivate: [FeatureArrivalGuard],
        data: { title: 'Cheguei' },
      },

      // ==================== NEWS ====================== //
      {
        path: 'news-list',
        component: NewsListComponent,
        canActivate: [ProfileGuard],
        data: {
          title: 'Notícias',
          expectedRole: RESTRICTED_ROUTE_PROFILES(BUSINESS_PROFILES),
        },
      },
      {
        path: 'news',
        component: NewsComponent,
        canActivate: [ProfileGuard],
        canDeactivate: [FormCanDeactivateGuard],
        data: {
          disableDrawer: true,
          title: 'Nova notícia',
          backPath: 'news-list',
          expectedRole: RESTRICTED_ROUTE_PROFILES(BUSINESS_PROFILES),
        },
      },
      {
        path: 'news/:id',
        component: NewsComponent,
        canActivate: [ProfileGuard],
        canDeactivate: [FormCanDeactivateGuard],
        data: {
          disableDrawer: true,
          title: 'Editar notícia',
          backPath: 'news-list',
          expectedRole: RESTRICTED_ROUTE_PROFILES(BUSINESS_PROFILES),
        },
      },

      {
        path: 'news/:id/details',
        component: NewsDetailsComponent,
        canActivate: [ProfileGuard],
        data: {
          close: true,
          title: 'Detalhes da notícia',
          expectedRole: RESTRICTED_ROUTE_PROFILES(BUSINESS_PROFILES),
        },
      },

      // ==================== CHAT ====================== //

      {
        path: 'chat',
        component: ChatsPageComponent,
        data: { title: 'Atendimento' },
      },
      {
        path: 'chat-details/:details',
        component: ChatsDetailsComponent,
        data: { disableDrawer: true },
      },

      /* ============= EVENTS =============== */
      {
        path: 'events-list',
        component: EventsListComponent,
        canActivate: [ProfileGuard],
        data: {
          title: 'Calendário',
          expectedRole: RESTRICTED_ROUTE_PROFILES(BUSINESS_PROFILES),
        },
      },
      {
        path: 'event',
        component: EventComponent,
        canActivate: [ProfileGuard],
        data: {
          disableDrawer: true,
          title: 'Criar novo evento',
          expectedRole: RESTRICTED_ROUTE_PROFILES(BUSINESS_PROFILES),
        },
      },
      {
        path: 'event/:id',
        component: EventComponent,
        canActivate: [ProfileGuard],
        data: {
          disableDrawer: true,
          title: 'Detalhamento de eventos',
          expectedRole: RESTRICTED_ROUTE_PROFILES(BUSINESS_PROFILES),
        },
      },

      /* ============= USERS =============== */

      {
        path: 'users',
        component: UserListComponent,
        canActivate: [ProfileGuard],
        data: {
          title: 'Usuários do sistema',
          expectedRole: RESTRICTED_ROUTE_PROFILES(EMPLOYEES_PROFILES),
        },
      },
      {
        path: 'user-form',
        component: UserFormComponent,
        canActivate: [ProfileGuard],
        data: {
          title: 'Gerenciar usuários',
          disableDrawer: true,
          expectedRole: RESTRICTED_ROUTE_PROFILES(EMPLOYEES_PROFILES),
          backPath: 'users',
        },
        resolve: { userData: UserFormResolver },
      },
      {
        path: 'user-details/:id',
        component: UserDetailsComponent,
        data: { disableDrawer: true },
      },
    ],
  },
];

const publicRoutes: Routes = [
  // ====== ALIASES (mantêm o código antigo funcionando) ======
  { path: 'login', redirectTo: 'auth/login', pathMatch: 'full' },
  { path: 'register', redirectTo: 'auth/register', pathMatch: 'full' },
  {
    path: 'forgot-password',
    redirectTo: 'auth/forgot-password',
    pathMatch: 'full',
  },
  { path: 'login-bypass', redirectTo: 'auth/login-bypass', pathMatch: 'full' },
  {
    path: 'select-tenant',
    redirectTo: 'auth/select-tenant',
    pathMatch: 'full',
  },
  {
    path: 'select-school',
    redirectTo: 'auth/select-school',
    pathMatch: 'full',
  },

  {
    path: 'auth',
    component: PublicLayoutComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'register',
        component: RegisterComponent,
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
      },
      {
        path: 'reset-password/:email',
        component: ResetPasswordComponent,
      },
      {
        path: 'login-bypass',
        component: LoginBypassComponent,
      },
      {
        path: 'select-tenant',
        component: SelectTenantComponent,
        canActivate: [AuthGuard, IntercomGuard],
      },
      {
        path: 'select-school',
        component: SelectSchoolComponent,
        canActivate: [AuthGuard, IntercomGuard],
      },
    ],
  },
];

const routes: Routes = [
  ...authRoutes,
  ...publicRoutes,
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
